export function getDomain() {
    const host = window.location.host.toLowerCase().split(":")[0];
    if (host === "m.scored.co" || host === "www.scored.co" || host === "scored.co") return "scored.co";
    return "communities.win";
}

export function showDomain(input) {

    if (input === "videy.co" || input === "cdn.videy.co" ||
        input === "media.patriots.win" || input === "media.scored.co" ||
        input === "media.communities.win" || input === "media.greatawakening.win" ||
        input === "media.kotakuinaction2.win" || input === "media.conspiracies.win" ||
        input === "media.omegacanada.win" || input === "twitter.com" || input === "x.com") return false;

    return true;

}